module.exports = __webpack_public_path__ + "static/media/unknown-user.a903b928.png";